var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Court") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.47 49.725v-2.074c0-2.3-1.476-4.26-3.53-4.986V24.683h1.772c.97 0 1.758-.787 1.758-1.758V17.05c0-.609-.315-1.175-.833-1.495L30.925.263a1.758 1.758 0 0 0-1.85 0L4.363 15.556c-.518.32-.833.886-.833 1.495v5.874c0 .97.787 1.758 1.758 1.758h1.773v17.982a5.296 5.296 0 0 0-3.53 4.986v2.074A5.297 5.297 0 0 0 0 54.712v3.53C0 59.212.787 60 1.758 60h56.484c.971 0 1.758-.787 1.758-1.758v-3.53c0-2.3-1.476-4.26-3.53-4.987ZM24.712 24.683v17.68h-7.075v-17.68h7.075Zm7.06 17.68h-3.544v-17.68h3.544v17.68Zm3.516-17.68h7.075v17.68h-7.075v-17.68Zm14.136 17.68h-3.545v-17.68h3.545v17.68ZM7.046 18.03 30 3.825 52.954 18.03v3.137H7.046V18.03Zm7.075 6.653v17.68h-3.545v-17.68h3.545ZM7.046 47.65c0-.977.795-1.772 1.772-1.772h42.364c.977 0 1.772.795 1.772 1.772v1.773H7.046V47.65Zm49.438 8.833H3.516v-1.772c0-.978.795-1.773 1.772-1.773h49.424c.977 0 1.772.795 1.772 1.773v1.772Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.002 8.232a5.294 5.294 0 0 0-5.288 5.289 5.294 5.294 0 0 0 5.288 5.288 5.294 5.294 0 0 0 5.288-5.289 5.294 5.294 0 0 0-5.288-5.288Zm0 7.061a1.774 1.774 0 0 1-1.772-1.772c0-.978.795-1.773 1.772-1.773.978 0 1.773.795 1.773 1.773 0 .977-.795 1.772-1.773 1.772Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourt);
export default __webpack_public_path__ + "static/media/court.4af937da.svg";
export { ForwardRef as ReactComponent };